import React from 'react';
// import { HashRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import lookup from "country-code-lookup"
import reportWebVitals from './reportWebVitals';
import './index.scss';
import App from './components/app/App';
import { loadRecaptcha }  from './components/reCaptcha/loadRecaptcha'
import { store } from './redux/store';
import { checkEmail, loadDomainRelatedData, loadTranslations, startPolling, loadLanguages, initializeMsalApp, initializeConfig,
          loadLinkInfo, loadFrontlineCountries, loadFrontlineCDProducts } from './services/api';
import { setDomainItem } from './utils/auth-utils';
import { getUrlParams, getContactParams } from './utils/url-utils';
import { MantineProvider } from '@mantine/core';
import theme from './theme';
import { appActions } from './redux/appSlice';
import { KeyValuePair, LinkInfo } from './redux/types';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MantineProvider theme={theme}>
        <App />
      </MantineProvider>
    </Provider>
  </React.StrictMode>
);

// initialize
(async () => {
  await initializeConfig(store)
  await initializeMsalApp()
  
  // load available languages
  // const dataLangs = await loadLanguages(store)
  loadLanguages(store)
    .then( (results:any) => {
      store.dispatch(appActions.setLanguages(results))
    })
  
  /* loadLanguages(store).then( (data) => {
    store.dispatch(appActions.setLanguages(data))
  }) */
  const urlParams = getUrlParams()
  if( urlParams.product &&
      urlParams.release &&
      urlParams.configId &&
      urlParams.productType &&
      urlParams.language )
  {

    store.dispatch(appActions.setValidUrlParams(true))

    // load translations for selected language 
    // const dataTranslations = await loadTranslations(store, urlParams.language)
    loadTranslations(store, urlParams.language)
      .then( (results:any) =>{
        store.dispatch(appActions.setTranslation(results))
      })

    // load available frontline countries for contact forms
    // const frontlines = await loadFrontlineCountries(store)
    loadFrontlineCountries(store)
      .then( (results:any) => {
        store.dispatch(appActions.setFrontlineCountries(results))
      })
    
    // load domain related information especially recapcha value
    const dataDomain = await loadDomainRelatedData(store)
    const domainItem = setDomainItem(dataDomain)
    store.dispatch(appActions.setDomainCountry(domainItem))
    
    store.dispatch(appActions.updateUrlParams(urlParams))
  
    if (domainItem?.recaptchaSiteKey) {
      loadRecaptcha(domainItem.recaptchaSiteKey)
    }
    
          // check if the email has already been set
    const emailStatus:KeyValuePair = await checkEmail(store,window.location.href)
    if(emailStatus.status ) {
      store.dispatch( appActions.setNotifyState('ready'))
    }
    if (emailStatus.key) {
      store.dispatch( appActions.setRowKey(emailStatus.key))      
    }
    // checkEmail(store,window.location.href)
    // .then( (emailStatus:KeyValuePair) => {
    //   if(emailStatus.status ) {
    //     store.dispatch( appActions.setNotifyState('ready'))
    //   }
    // })
  

    // if the first user refreshes the page, get the email set
    const currentEmail = window.sessionStorage.getItem("currentEmail")
    if(currentEmail) {
      store.dispatch( appActions.setCurrentEmail(currentEmail))
    }

    // load information concerning the request
    // const linkInfo:LinkInfo = await loadLinkInfo(store)
    // store.dispatch( appActions.setLinkData(linkInfo))
    loadLinkInfo(store)
      .then( (linkInfo:LinkInfo) => {
        store.dispatch( appActions.setLinkData(linkInfo))
        if(linkInfo.destinationCountry) {
          const countryName = lookup.byInternet(linkInfo.destinationCountry)
          if(countryName?.country) {
            // load product offering for selected destination country (for Car Designer link)
            // const countryOffering:any[] = await loadFrontlineCDProducts(store, countryName?.country) || []
            // if(countryOffering) {
            //   store.dispatch( appActions.setCDProducts(countryOffering) )
            // }
            loadFrontlineCDProducts(store, countryName?.country)
              .then( (results:any) => {
                if(results) {
                  store.dispatch( appActions.setCDProducts(results) )
                }
              })
          }
        }
      })


    startPolling(store, emailStatus)

    store.dispatch( appActions.setInitialized(true))

  } else {
    const urlParamsContact = getContactParams()
    // console.log({urlParamsContact})
  
    if(urlParamsContact.contact) {
      store.dispatch(appActions.setShowContactForm(true))      
      store.dispatch(appActions.setProductType(urlParamsContact.productType))      
    }

    const dataTranslations = await loadTranslations(store, 'en_US')
    store.dispatch(appActions.setTranslation(dataTranslations))

    const frontlines = await loadFrontlineCountries(store)
    store.dispatch(appActions.setFrontlineCountries(frontlines))

    store.dispatch(appActions.setLanguage('en'))
    
    const dataDomain = await loadDomainRelatedData(store)
    const domainItem = setDomainItem(dataDomain)
    store.dispatch(appActions.setDomainCountry(domainItem))

    if (domainItem?.recaptchaSiteKey) {
      loadRecaptcha(domainItem.recaptchaSiteKey)
    }

    store.dispatch( appActions.setInitialized(true))
  }
  
})()




// TODO: Get translations from
// https://admin-cardesigner.kone.com/api/public/translation/en_US

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
